import { CanActivateFn, ActivatedRouteSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { IrisGlobalSandbox } from '@iris/common/redux/global.sandbox';
import { toSignal } from '@angular/core/rxjs-interop';
import { IRIS_APPLICATION_ALIAS } from '@iris/common/models/IrisApplication';

export const applicationExistsGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  const globalSandbox = inject(IrisGlobalSandbox);
  const applications = toSignal(globalSandbox.applications$);
  const appAlias = route.paramMap.get('appAlias');

  if (appAlias === IRIS_APPLICATION_ALIAS) {
    return true;
  }

  if (appAlias) {
    const appExists = applications().some(app => app.applicationAlias === appAlias);

    if (appExists) {
      return true;
    }
  }

  console.warn(`Attempted access to non-existent application alias: ${appAlias}`);

  // Instead of redirecting with router to root path, it forces a full page reload to perform all backend calls with
  // the correct appAlias
  window.location.href = window.location.origin + '/';

  return false;
};
